export class UTILS__type {
  private static is_array_of__base(target: unknown, type: string): boolean {
    if (!Array.isArray(target)) return false;
    if (target.is_empty()) return false;

    let out = target.every(item => typeof item === type);
    return out;
  }

  static is_array_of__primitive(target: unknown): boolean {
    if (!Array.isArray(target)) return false;
    if (target.is_empty()) return false;

    let out = target.every(item => this.is_primitive(item));
    return out;
  }

  static is_array_of__string(target: unknown): boolean {
    return UTILS__type.is_array_of__base(target, 'string');
  }

  static is_array_of__boolean(target: unknown): boolean {
    return UTILS__type.is_array_of__base(target, 'boolean');
  }

  static is_primitive(value: any): boolean {
    let primitive_types = new Set(['string', 'number', 'boolean', 'bigint', 'symbol']);

    const type = typeof value;

    let out = primitive_types.has(type);

    return out;
  }

  static are_same_primitive_types(value_a: any, value_b: any): boolean {
    if (!this.is_primitive(value_a)) return false;
    if (!this.is_primitive(value_b)) return false;

    let type_a = typeof value_a;
    let type_b = typeof value_b;

    let out = type_a == type_b;

    return out;
  }

  static are_same_type_array_of_primitives(value_a: any, value_b: any): boolean {
    if (!Array.isArray(value_a)) return false;
    if (!Array.isArray(value_b)) return false;

    if (value_a.is_empty()) return false;
    if (value_b.is_empty()) return false;

    if (!value_a.every(item => this.is_primitive(item))) return false;
    if (!value_b.every(item => this.is_primitive(item))) return false;

    let type_a = this.typeof(value_a[0]);
    let type_b = this.typeof(value_b[0]);

    if (type_a != type_b) return false;

    let out = value_a.every(item => this.typeof(item) == type_a) && value_b.every(item => this.typeof(item) == type_b);

    return out;
  }

  static are_both_objects(value_a: any, value_b: any): boolean {
    if (this.typeof(value_a) != 'object') return false;
    if (this.typeof(value_b) != 'object') return false;

    return true;
  }

  static typeof(value: any): string {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';

    return typeof value;
  }

  static is_object(value: any): boolean {
    return this.typeof(value) == 'object';
  }
}

export function is_instance_of<C>(instance: unknown, class_object: new () => C): boolean {
  return (instance as object).constructor && (instance as object).constructor.name == class_object.name;
}

export function utils_typed_entries<T extends object>(target: T) {
  return Object.entries(target) as [keyof T, T[keyof T]][];
}
